var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-alert',{class:{'mb-0': _vm.noBottomMargin},attrs:{"icon":_vm.icon === null ? false : _vm.icon,"type":_vm.type,"tile":_vm.tile,"dense":_vm.dense,"text":"","elevation":_vm.elevation.toString()}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }